import { Schema } from 'effect';

/**
 * Every property a component can be configured by, as the engine names them.
 *
 * The frontend's copy of the backend's own `AttributeType`, kept strict for the same reason {@link ComponentTypes} is, and failing the same way when the two drift. The codes are the engine's shorthand — `hd` is height, `nn` is name — and what a user reads is never one of these but the label the engine writes beside it.
 * See `ConfigurationParameter.label`.
 *
 * Kept in the backend's order rather than sorted, so the two lists can be read side by side.
 */
export const AttributeTypes = Schema.Literals([
	'hd',
	'bd',
	'eb',
	'ld',
	'fb',
	'fh',
	'f1',
	'f2',
	'u1',
	'u2',
	'u3',
	'u4',
	'u5',
	'u6',
	'u7',
	'u8',
	'op',
	'up',
	'vp',
	'hp',
	'xk',
	'yk',
	'rt',
	'ih',
	'm1',
	'm2',
	'm3',
	'm4',
	'm5',
	'p1',
	'p2',
	'p3',
	'p4',
	'p5',
	'p6',
	'p7',
	'p8',
	'tv',
	'tl',
	'ty',
	'ob',
	'og',
	'sg',
	'ug',
	'hb',
	'hs',
	'hg',
	'nn',
	'mg',
	'st',
	'mx',
	'bg',
	'tt',
	'ol',
	'sl',
	'ul',
	't0',
	't1',
	't2',
	't3',
	't4',
	't5',
	't6',
	't7',
	't8',
	't9',
	'tg',
	'h1',
	'lh',
	'lb',
	'nr',
	'pg',
	'pl',
	'dl',
	'ft',
	'sn',
	'kb',
	'ko',
	'f3',
	'm6',
	'm7',
	'm8',
	'm9',
	'm0',
	'ps',
	'ok',
	'pt',
	'fd',
	'h2',
	'h3',
	'h4',
	'kg',
	'gl',
	'ti',
	'tr',
	'al',
	'ma',
	'mb',
	'mc',
	'md',
	'me',
	'mf',
	'mh',
	'mi',
	'mj',
	'fo',
	'lo',
	'u9',
	'ua',
	'ub',
	'uc',
	'ud',
	'ue',
	'uf',
	'ex',
	'fl',
	'g0',
	'g1',
	'g2',
	'g3',
	'g4',
	'g5',
	'g6',
	'g7',
	'g8',
	'g9',
	'mo',
	'mk',
	'ml',
	'mm',
	'mn',
	'mp',
	'g10',
	'g11',
	'g12',
	'g13',
	'g14',
	'g15',
	'g16',
	'g17',
	'g18',
	'g19',
	'g20',
	'g21',
	'g22',
	'g23',
	'g24',
	'g25',
	't10',
	't11',
	't12',
	't13',
	't14',
	't15',
	't16',
	't17',
	't18',
	't19',
	't20',
	't21',
	't22',
	't23',
	't24',
	't25',
	'ph',
	'gr',
	'id',
	'lg',
	'gs',
	'ks',
]);

/** One of the properties a component can be configured by. */
export type IAttributeType = typeof AttributeTypes.Type;
